import React from "react";
import { styled } from "@mui/material/styles";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import CheckIcon from "@mui/icons-material/Check";
import { ThemeColor } from "../../component/theme/color";

/**
 * The seven steps of the payout workflow, in order.
 *
 * Shared so the student view and the university/organisation views draw the
 * same stations in the same order with the same wording - they are describing
 * one process, and two copies of this list would eventually disagree.
 */
export const TRACKING_STEPS = [
  {
    key: "isUniversityListExport",
    dateKey: "universityListExportDate",
    label: "University Export",
  },
  {
    key: "isImportUniversityTransaction",
    dateKey: "importUniversityTransactionDate",
    label: "Transaction Import",
  },
  {
    key: "isUniversityInvoiceExport",
    dateKey: "universityInvoiceExportDate",
    label: "Invoice Export",
  },
  {
    key: "isImportCreditedAmount",
    dateKey: "importCreditedAmountDate",
    label: "Credited Amount",
  },
  {
    key: "isExportForOrganisation",
    dateKey: "exportForOrganisationDate",
    label: "Organization Export",
  },
  {
    key: "isExportForOrganisationInvoice",
    dateKey: "exportForOrganisationInvoiceDate",
    label: "Org Invoice Export",
  },
  {
    key: "isSettledAgentTransaction",
    dateKey: "settledAgentTransactionDate",
    label: "Agent Settled",
  },
];

export const formatStageDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const QontoConnector = styled(StepConnector)(() => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: "calc(-50% + 16px)",
    right: "calc(50% + 16px)",
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: ThemeColor.PURPLE,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: ThemeColor.PURPLE,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: "#E2E8F0",
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

const QontoStepIconRoot = styled("div")(({ ownerState }) => ({
  color: ownerState.active ? ThemeColor.PURPLE : "#CBD5E1",
  display: "flex",
  height: 22,
  alignItems: "center",
  "& .qontoStepIcon-completedIcon": {
    color: "#10B981",
    zIndex: 1,
    fontSize: 18,
  },
  "& .qontoStepIcon-circle": {
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: "currentColor",
  },
}));

export function QontoStepIcon(props) {
  const { active, completed, className } = props;
  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      {completed ? (
        <CheckIcon className="qontoStepIcon-completedIcon" />
      ) : (
        <div className="qontoStepIcon-circle" />
      )}
    </QontoStepIconRoot>
  );
}

/** How far along a set of stages is, for the Stepper's `activeStep`. */
export const activeStepOf = (stages) => {
  let active = 0;
  (stages || []).forEach((stage, index) => {
    if (stage.done) active = index + 1;
  });
  return active;
};
